import { z } from "zod";
import {
    NumberFormatAmountScale,
    NumberFormatCurrencyPlacement,
    NumberFormatCurrencySymbol,
    NumberFormatNegativeFormat,
    NumberFormatZeroDisplay,
} from "@common/types/reports/number-format-settings";

export const NUMBER_FORMAT_DECIMAL_PLACES = [0, 2, 4] as const;
export const NUMBER_FORMAT_PERCENT_DECIMAL_PLACES_MAX = 4;

const decimalPlacesSchema = z.union([z.literal(0), z.literal(2), z.literal(4)]);

const percentDecimalPlacesSchema = z
    .number()
    .int()
    .min(0)
    .max(NUMBER_FORMAT_PERCENT_DECIMAL_PLACES_MAX);

export const numberFormatValuesSchema = z.object({
    decimalPlaces: decimalPlacesSchema,
    negativeFormat: z.nativeEnum(NumberFormatNegativeFormat),
    isNegativeInRed: z.boolean(),
    hasThousandsSeparator: z.boolean(),
    zeroDisplay: z.nativeEnum(NumberFormatZeroDisplay),
    currencySymbol: z.nativeEnum(NumberFormatCurrencySymbol),
    currencyPlacement: z.nativeEnum(NumberFormatCurrencyPlacement),
    percentDecimalPlaces: percentDecimalPlacesSchema,
    amountScale: z.nativeEnum(NumberFormatAmountScale),
});
export type NumberFormatValues = z.infer<typeof numberFormatValuesSchema>;

export const numberFormatOwnValuesSchema = z.object({
    decimalPlaces: decimalPlacesSchema.nullable(),
    negativeFormat: z.nativeEnum(NumberFormatNegativeFormat).nullable(),
    isNegativeInRed: z.boolean().nullable(),
    hasThousandsSeparator: z.boolean().nullable(),
    zeroDisplay: z.nativeEnum(NumberFormatZeroDisplay).nullable(),
    currencySymbol: z.nativeEnum(NumberFormatCurrencySymbol).nullable(),
    currencyPlacement: z.nativeEnum(NumberFormatCurrencyPlacement).nullable(),
    percentDecimalPlaces: percentDecimalPlacesSchema.nullable(),
    amountScale: z.nativeEnum(NumberFormatAmountScale).nullable(),
});
